<script setup>
import { computed } from 'vue'

import EventTable from '@/components/EventTable.vue'

import { useSettingsStore } from '@/stores/SettingsStore.js'
import { useTableStore } from '@/stores/TableStore.js'
import { useParticipateStore } from '@/stores/ParticipateStore.js'

const settingsStore = useSettingsStore()
const tableStore = useTableStore()
const participateStore = useParticipateStore()

const columnClass = computed(() => {
    if (settingsStore.numberOfColumns == 0) {
        return 'auto-grid'
    }

    return 'row-cols-' + settingsStore.numberOfColumns
})

const fontSizeClass = computed(() => {
    return 'fs-' + settingsStore.fontSize
})

function createNewTable() {
    tableStore.createNewTable()
}

function removeUnusedTables() {
    tableStore.removeUnusedTables()
}

function lockAllAssigned() {
    participateStore.setAllLocked(true)
}

function unlockAllAssigned() {
    participateStore.setAllLocked(false)
}

</script>

<template>
    <div :class="fontSizeClass">
        <div class="text-center" v-if="tableStore.tables.length == 0">
            <span class="col text-center w-100"><i>There are currently no generated tables...</i></span>
            <br><br>
            <button type="button" class="btn btn-success" @click="createNewTable">Create a New Table</button>
        </div>

        <div v-else :class="'row ' + columnClass + ' g-3'">
            <span class="col" v-for="table, i in tableStore.tables">
                <EventTable :table="table" :number="i"></EventTable>
            </span>

            <span class="col text-center"  v-if="settingsStore.showOptions === true">
                <div class="btn-group-vertical w-100 mb-2" role="group" aria-label="Vertical button group">
                    <button type="button" class="btn btn-success" @click="createNewTable">Create a New Table</button>
                </div>
                <div class="btn-group-vertical w-100" role="group" aria-label="Vertical button group">
                    <button type="button" class="btn btn-outline-primary" @click="lockAllAssigned">Lock All Assigned</button>
                    <button type="button" class="btn btn-outline-primary" @click="unlockAllAssigned">Unlock All Assigned</button>
                </div>
            </span>
        </div>
    </div>
</template>

<style>

.auto-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr))
}

</style>
